








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class IconSvg extends Vue {
	@Prop()
	private type!: any

	@Prop()
	private size!: any

	@Prop()
	private fill!: any

	private get iconName() {
		return `#icon-${this.type}`
	}
}
